import Inputer from 'Utils/Helpers/Inputer';
import { TextShow } from 'Utils/Helpers/TextShow';
import { useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import { changeTolerance } from '../../../../../Redux/slices/globalSlice';

export default function Tolerance({ extraCount }) {
    const dispatch = useDispatch();

    const setControlsValue = (name, value) => {
        dispatch(changeTolerance(value))
    }

    return (
        <div className='mt-4'>
            <TextShow
                title={"تلورانس نوبت در هر روز"}
                icon={<icons.ExclamationCircle size={18} />}
                justText
                className={'no-hide text-muted'}
            />
            <div className='mt-2 flex-row-between-center flex-wrap' style={{padding: '0 10px'}}>
                <Inputer
                    key={`inputer`}
                    id={'tolerance'}
                    type={'number'}
                    placeholder={'تلورانس'}
                    value={extraCount}
                    setValue={setControlsValue.bind(this)}
                    icon={<icons.ExclamationCircle />}
                    className={'day-count'}
                />
            </div>
        </div>
    );
}